import { Controller } from "stimulus"

// Keeps a Turbo Frame's content when a response comes back without the frame
// (a server error page or a proxy error) instead of Turbo's "Content missing",
// and shows a short message so nothing typed is lost:
//   <turbo-frame data-controller="frame-error"
//                data-action="turbo:frame-missing->frame-error#keep"
//                data-frame-error-message-value="That didn't go through. Please try again."
//                data-frame-error-within-value="form">
// The message goes at the top of the "within" element, or at the end of the frame.
export default class extends Controller {
  static values = { message: String, within: String, noticeClass: String }

  keep(event) {
    event.preventDefault()
    if (!this.messageValue) return

    const host = (this.withinValue && this.element.querySelector(this.withinValue)) || this.element
    let notice = Array.from(host.children).find(child => child.hasAttribute("data-frame-error-notice"))
    if (!notice) {
      notice = document.createElement("p")
      notice.setAttribute("role", "alert")
      notice.setAttribute("data-frame-error-notice", "")
      if (this.noticeClassValue) notice.className = this.noticeClassValue
      this.withinValue ? host.prepend(notice) : host.append(notice)
    }
    notice.textContent = this.messageValue
  }
}
